import { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import ReactTooltip from 'react-tooltip'
import { COPY_CODE_MESSAGE } from 'app-constants'
import { Button } from '../button'
import './style.scss'

export function BillsButton({
  icon,
  onClick = () => {},
  label = '',
  copyToClipboard = false,
  copyMessage = '',
  codeBar = '',
  small = false,
}) {
  const [tooltipMessage, setTooltipMessage] = useState(copyMessage)

  function handleClick() {
    if (copyToClipboard) {
      setTooltipMessage(copyMessage)
      return
    }

    onClick()
  }

  function handelMouseEnter() {
    setTooltipMessage(COPY_CODE_MESSAGE)
  }

  function handelMouseLeave() {
    setTooltipMessage('')
  }

  function renderCopyToClipboard() {
    return (
      <CopyToClipboard data-for='barcode-tip' data-tip='' text={codeBar}>
        {renderButton()}
      </CopyToClipboard>
    )
  }

  function renderButton() {
    return (
      <Button
        className={`bills-button ${small && '-small'}`}
        size={null}
        icon={icon}
        onClick={handleClick}
        onMouseLeave={handelMouseLeave}
        onMouseEnter={handelMouseEnter}
        color='primary'
      >
        {label}
        <ReactTooltip
          id='barcode-tip'
          effect='solid'
          place='bottom'
          getContent={() => tooltipMessage}
        />
      </Button>
    )
  }

  function renderContent() {
    if (copyToClipboard) return renderCopyToClipboard()

    return renderButton()
  }

  return renderContent()
}
